import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function Contact() {
  useScrollAnimation();

  useEffect(() => {
    document.title = 'Contact | Audacious Quest PTE Ltd';
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      {/* Contact Heading */}
      <section className="py-8 md:py-12 px-4 md:px-6 scroll-animate">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading text-primary-900 mb-4">
            Contact
          </h1>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-8 md:py-12 px-4 md:px-6 scroll-animate">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-8 md:gap-12 items-center">
          <div className="w-full md:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20kinetic%20sculpture%20with%20marble%20spheres%20delicately%20balanced%20on%20wooden%20beams%2C%20neutral%20warm%20gray%20studio%20background%2C%20conceptual%20art%20representing%20precision%20and%20equilibrium%2C%20soft%20diffused%20lighting%2C%20museum%20quality%20still%20life%20photography%2C%20elegant%20composition&width=600&height=500&seq=contact-balance&orientation=squarish"
              alt="Balance and precision"
              className="w-full h-64 md:h-[400px] object-cover object-top rounded-lg"
            />
          </div>
          <div className="w-full md:w-1/2">
            <h2 className="text-2xl md:text-3xl font-heading text-primary-900 mb-6">
              Audacious Quest Pte
            </h2>
            <div className="mb-6">
              <p className="text-xs text-foreground-500 tracking-wider mb-1">REACH US AT</p>
              <a
                href="mailto:contact@audaciousquestpl.com"
                className="text-accent-600 hover:text-accent-700 transition-colors text-sm md:text-base"
              >
                contact@audaciousquestpl.com
              </a>
            </div>
            <div>
              <p className="text-xs text-foreground-500 tracking-wider mb-1">
                REGISTERED OFFICE ADDRESS:
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                6 EU TONG SEN STREET #12-12 THE CENTRAL SINGAPORE (059817)
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}